import { render, staticRenderFns } from "./ListClausulaservicoPage.vue?vue&type=template&id=5b3633ec&"
import script from "./ListClausulaservicoPage.vue?vue&type=script&lang=js&"
export * from "./ListClausulaservicoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports